import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const StockValueMovement = {
	name: NAME,
	apiProvider,
	router,
};
